module.exports = __webpack_public_path__ + "img/ring_r_e_1_0@2x.28de9b5e.png";